import { createSlice } from "@reduxjs/toolkit";

import PriceZone from "../../../../../services/PriceZone/PrizeZone";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, PriceZone.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStatePriceZoneData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.PRIZE_ZONES_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStatePriceZoneDataAction = globalStatePriceZoneData.actions;
export const globalStatePriceZoneDataReducer = globalStatePriceZoneData.reducer;
export type globalStatePriceZoneDataState = State;

export default globalStatePriceZoneData;
